var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 5.7C3.80218 5.7 3.42064 5.54197 3.13934 5.26066C2.85804 4.97936 2.7 4.59783 2.7 4.2C2.7 3.80218 2.85804 3.42064 3.13934 3.13934C3.42064 2.85804 3.80218 2.7 4.2 2.7C4.59783 2.7 4.97936 2.85804 5.26066 3.13934C5.54197 3.42064 5.7 3.80218 5.7 4.2C5.7 4.39698 5.6612 4.59204 5.58582 4.77403C5.51044 4.95601 5.39995 5.12137 5.26066 5.26066C5.12137 5.39995 4.95601 5.51044 4.77403 5.58582C4.59204 5.6612 4.39698 5.7 4.2 5.7ZM4.2 0C3.08609 0 2.0178 0.442499 1.23015 1.23015C0.442499 2.0178 0 3.08609 0 4.2C0 7.35 4.2 12 4.2 12C4.2 12 8.4 7.35 8.4 4.2C8.4 3.08609 7.9575 2.0178 7.16985 1.23015C6.3822 0.442499 5.31391 0 4.2 0Z",
    fill: "#004D91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.44216915767503fdcd86e8012a9fe7dd.svg";
export { ForwardRef as ReactComponent };